import { render, staticRenderFns } from "./TraducaoField.vue?vue&type=template&id=a2cf5222"
import script from "./TraducaoField.vue?vue&type=script&setup=true&lang=js"
export * from "./TraducaoField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports